module.exports = __webpack_public_path__ + "img/video-production.3c0117b6.jpg";